module.exports = __webpack_public_path__ + "img/menu-abonent.987d1646.svg";